import { render, staticRenderFns } from "./PurchaseList.vue?vue&type=template&id=7ab98bea"
import script from "./PurchaseList.vue?vue&type=script&lang=js"
export * from "./PurchaseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ab98bea')) {
      api.createRecord('7ab98bea', component.options)
    } else {
      api.reload('7ab98bea', component.options)
    }
    module.hot.accept("./PurchaseList.vue?vue&type=template&id=7ab98bea", function () {
      api.rerender('7ab98bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/purchase/components/PurchaseList.vue"
export default component.exports